var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('canvas',{staticClass:"canvas-layer canvas-drawable",style:({'z-index': _vm.zindex, 'display': _vm.display}),attrs:{"id":_vm.componentId,"width":"1354","height":"160"}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-507beb0e","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/layers/TemplateLayer.vue
// module id = 140
// module chunks = 0